// Confluence persists extension nodes through its core macro storage format.
export const KNOWLEDGE_CARD_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';

export const KNOWLEDGE_CARD_MANIFEST_KEY = 'knowledge-card';
